// extracted by mini-css-extract-plugin
module.exports = {"root":"EnquiryForm_root__15qMa","icon":"EnquiryForm_icon__rvmdL","heading":"EnquiryForm_heading__3PrmR","field":"EnquiryForm_field__1GTQt","error":"EnquiryForm_error__3sUg2"};